module.exports = __webpack_public_path__ + "img/hello-javascript.07962b07.png";